import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import DefaultToggle from './DefaultToggle';
import { AvInput } from 'availity-reactstrap-validation';

const LabeledToggle = ({
  wrapperClassName,
  headingClassName,
  headingMessageId,
  subHeadingClassName,
  subHeadingMessageId,
  toggleWrapperClassName,
  onClick,
  withoutCheckIcon,
  leftStyles,
  propertyName,
  checked,
  targetObject,
  ...props
}) => {
  const [inputValue, setInputValue] = useState(false);
  useEffect(() => {
    if (targetObject && propertyName) {
      setInputValue(targetObject[propertyName]);
    }
  }, [targetObject]);

  return (
    <div
      className={
        wrapperClassName ||
        'd-flex align-content-center justify-content-between'
      }
    >
      {(headingMessageId || subHeadingMessageId) && (
        <div style={leftStyles} className="mr-2">
          {headingMessageId && (
            <span className={`d-block black font-medium-1 ${headingClassName}`}>
              <FormattedMessage id={headingMessageId} />
            </span>
          )}
          {subHeadingMessageId && (
            <span className={subHeadingClassName || 'd-block font-small-2'}>
              <FormattedMessage id={subHeadingMessageId} />
            </span>
          )}
        </div>
      )}
      <DefaultToggle
        toggleWrapperClassName={
          toggleWrapperClassName || 'd-inline-flex react-toggle-wrapper'
        }
        withoutCheckIcon={withoutCheckIcon}
        onClick={(e) => {
          if (onClick) {
            onClick(e);
          } else {
            setInputValue(!inputValue);
          }
        }}
        checked={checked || inputValue}
        {...props}
      />
      {propertyName && (
        <AvInput
          className="text-center"
          type="text"
          name={propertyName}
          value={inputValue}
          hidden
        />
      )}
    </div>
  );
};

export default LabeledToggle;
